import { render, staticRenderFns } from "./month.vue?vue&type=template&id=188ae22a&scoped=true&"
import script from "./month.vue?vue&type=script&lang=js&"
export * from "./month.vue?vue&type=script&lang=js&"
import style0 from "./month.vue?vue&type=style&index=0&id=188ae22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ae22a",
  null
  
)

export default component.exports